<template>
  <div class="card card-flush mb-5 mb-xl-8">
    <div class="card-header">
      <h3 class="card-title fw-bold">
        <i class="bi bi-person-x text-danger me-2"></i>
        Desativar conta
      </h3>
      <div class="card-toolbar">
        <span class="text-muted fs-7">Encerre seu acesso à plataforma</span>
      </div>
    </div>

    <div class="card-body pt-5">
      <p class="text-muted fs-7 mb-0">
        Sua conta deixa de ter acesso ao sistema e ao aplicativo da Ubbimed.
        Os prontuários e documentos que você emitiu continuam guardados pelo
        prazo que a legislação exige. Para voltar a usar, fale com o suporte.
      </p>
    </div>

    <div class="card-footer d-flex justify-content-end py-6">
      <button type="button" class="btn btn-light-danger" @click="confirmDeactivate">
        <i class="bi bi-person-x me-1"></i>
        Desativar minha conta
      </button>
    </div>
  </div>

  <div class="modal fade" id="accountDeactivateModal" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Desativar conta</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">
          <p class="text-muted fs-7">
            Para desativar a conta, informe a senha que você usa no login.
          </p>
          <label class="form-label">Senha atual</label>
          <input
            v-model="password"
            type="password"
            class="form-control"
            @keyup.enter="deactivate"
          />
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancelar</button>
          <button type="button" class="btn btn-danger" :disabled="busy || !password" @click="deactivate">
            <span v-if="!busy">Desativar conta</span>
            <span v-else>
              Desativando...
              <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '../helpers/http';
import Alert from '../helpers/alert';
import Modal from '../helpers/modal';

export default {
  name: 'AccountDeactivateSection',
  data() {
    return {
      busy: false,
      password: '',
    };
  },
  methods: {
    confirmDeactivate() {
      Swal.fire({
        title: 'Desativar conta',
        text: 'Você perde o acesso ao sistema e ao aplicativo. Sua agenda deixa de receber novos agendamentos e só o suporte consegue reativar a conta.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#780f5a',
        confirmButtonText: 'Sim, desativar',
        cancelButtonText: 'Não',
      }).then((result) => {
        if (!result.isConfirmed) return;

        this.password = '';
        Modal.toggle('#accountDeactivateModal');
      });
    },
    deactivate() {
      if (this.busy || !this.password) return;

      this.busy = true;
      http.post('/auth/account/deactivate', { current_user_password: this.password })
        .then(() => {
          Modal.hide('#accountDeactivateModal');
          this.password = '';

          return this.$store.dispatch('auth/logout');
        })
        .then(() => {
          window.location.replace('/login');
        })
        .catch((error) => {
          Alert.toastError(this.messageFrom(error));
        })
        .finally(() => {
          this.busy = false;
        });
    },
    messageFrom(error) {
      const data = error.response?.data;
      if (typeof data === 'string' && data) return data;

      const field = data?.errors?.current_user_password;
      if (Array.isArray(field) && field.length) return field[0];

      return data?.message ?? 'Não foi possível desativar a conta.';
    },
  },
};
</script>
